<template>
  <section class="container__button">
    <button @click="btnAbort" class="container__button-close">
      <span aria-hidden="true" :style="`font-size: ${fontSize}px`"
        >&#10005;</span
      >
    </button>
  </section>
</template>

<script>
export default {
  name: "ButtonClose",

  data() {
    return {};
  },
  props: {
    fontSize: { type: String, required: false, default: "20" }
  },
  methods: {
    btnAbort() {
      this.$emit("btnAbort");
    }
  }
};
</script>

<style scoped>
.container__button {
  position: sticky;
  left: calc(100% - 40px);
  top: 1%;
  display: flex;
  width: 100%;
  max-width: 30px;
  height: 100%;
  max-height: 30px;
  z-index: 1;
}
.container__button-close {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  align-items: center;
  border: 1px solid var(--textinactive);
  border-radius: 50px;
}
.container__button-close:hover {
  transform: scale(1.10);
}
</style>
